<script lang="ts" setup>
import { useRegisterSW } from 'virtual:pwa-register/vue';

useRegisterSW({ immediate: true });
</script>

<template>
   <div></div>
</template>
